import {Handler} from "../../Utils";

export interface ValidationError {
    message: string
}

export interface IDispatcher {
    onChange(id: string, value: any, valid: boolean, error: ValidationError | undefined): void;
    onBlur(id: string, value: any, valid: boolean, error: ValidationError | undefined): void;
    onVisit(id: string);
    onLoadFile(id:string, state: object): void;
    onAddValueRefresh(id: string, value: any, error: ValidationError | undefined);
    bind(name: string, handler: Handler): Handler;
    setError(id: string, value: any, error: { message } | undefined, skipCommonValidation: boolean): void;
}

export abstract class Dispatcher implements IDispatcher {

    abstract onAddValueRefresh(id: string, value: any, error: ValidationError | undefined): void;
    
    abstract onChange(id: string, value: any, valid: boolean, error: ValidationError | undefined): void;

    abstract onBlur(id: string, value: any, valid: boolean, error: ValidationError | undefined): void;
    
    abstract onVisit(id: string);

    abstract setError(id: string, value: any, error: { message } | undefined, skipCommonValidation: boolean): void;

    abstract onLoadFile(id:string, state: object): void;

    private events: {[name: string]: Handler[]} = {};

    bind(name: string, handler: Handler): Handler {

        let event = this.events[name];
        if(event == undefined) {
            event = [];
            this.events[name] = event;
        }

        event.push(handler);

        return function () {
            const i = event.indexOf(handler);
            event = event.splice(i, 1);
            this.events[name] = event;
        }
    }

    public invoke(name: string, ...args: any[]) {
        for(const ev of this.events[name]) {
            ev(...args);
        }
    }
}

export class ControlValueDispatcher extends Dispatcher{
    public controlVisited: (id: string) => void;

    addControlRefres: any;
    public addControlValue: (id:string, value:any, valid:boolean, error: ValidationError | undefined) => void;

    public addControlRefresh: (id:string, value:any, error: ValidationError | undefined) => void;

    public copyValue: (source: string, target:string) => void;

    public addFile: (id:string, state: object) => void;
    
    public error: (id: string, value: any, error: ValidationError | undefined, skipCommonValidation: boolean) => void;

    onVisit(id: string) {
        this.controlVisited(id);
    }

    onChange(id: string, value: any, valid: boolean, error: ValidationError | undefined): void {} 
    
    onBlur(id: string, value: any, valid: boolean, error: ValidationError): void {
        this.addControlValue(id, value, valid, error)
    }

    onLoadFile(id:string, state: object){
        this.addFile(id, state);
    }

    onAddValueRefresh(id: string, value: any, error: ValidationError | undefined): void {
        this.addControlRefresh(id, value, error);
    }

    setError(id: string, value: any, error: { message } | undefined, skipCommonValidation: boolean = false): void {
        this.error(id, value, error, skipCommonValidation);
    }

}


// WEBPACK FOOTER //
// ./src/components/controls/extensions/Dispatcher.tsx